import { __awaiter } from "tslib";
import React, { Component } from 'react';
import ReactDOM from 'react-dom/client';
import Swal from 'sweetalert2';
import httpService from '../services/http.service';
import { currency_format, t } from '../utils';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { isFullScreen, toogleFullScreen } from '../fullscreen';
import { Modal } from 'bootstrap';
import uuid from 'react-uuid';
import { UserCircleIcon } from '@heroicons/react/24/solid';
import { XCircleIcon, ChevronDownIcon } from '@heroicons/react/24/outline';
const priceFilterList = ['Retail Prices', 'Wholesale Prices', 'Super Dealer Prices'];
class PointOfSaleEdit extends Component {
    constructor(props) {
        super(props);
        this.getAppSettings = () => {
            return JSON.parse(this.props.settings);
        };
        this.getCarTypes = () => {
            return JSON.parse(this.props.cartypes);
        };
        this.setupForEditing = () => __awaiter(this, void 0, void 0, function* () {
            var order = JSON.parse(this.props.order);
            console.log(order);
            this.setState({ orderId: order.id });
            this.setState({ orderNumber: order.number });
            this.setState({
                saleType: order.sale_type === 'government' || order.government_invoice_number ? 'government' : 'customer',
                isQuotation: Boolean(order.is_quotation)
            });
            this.setState({ deliveryCharge: order.delivery_charge });
            this.setState({ tax: order.tax_rate });
            this.setState({ vatType: order.vat_type });
            this.setState({ discount: order.discount });
            this.setState({ currentPrice: order.price_type });
            let cartItems = [];
            order.order_details.map((item) => {
                let cartItem = {
                    cartId: uuid(),
                    id: item.product.id,
                    name: item.product.name,
                    full_name: item.product.name,
                    description: item.product.description,
                    quantity: item.quantity,
                    old_quantity: item.quantity,
                    discount: item.quantity && item.price
                        ? (Number(item.discount || 0) / (Number(item.quantity) * Number(item.price))) * 100
                        : 0,
                    image_url: item.product.image_url,
                    // barcode: item.barcode,
                    wholesale_barcode: item.wholesale_barcode,
                    retail_barcode: item.retail_barcode,
                    // sku: item.sku,
                    wholesale_sku: item.wholesale_sku,
                    retail_sku: item.retail_sku,
                    in_stock: item.in_stock,
                    track_stock: item.track_stock,
                    continue_selling_when_out_of_stock: item.continue_selling_when_out_of_stock,
                    price: item.price,
                    wholesale_price: item.wholesale_price,
                    retailsale_price: item.retailsale_price,
                    cost: item.cost
                };
                cartItems.push(cartItem);
            });
            this.setState({ cart: cartItems });
            if (order.customer) {
                this.setState({
                    customer: {
                        id: order.customer.id,
                        name: order.customer.name,
                        full_address: order.customer.full_address,
                        contact: order.customer.contact,
                        order_details: []
                    }
                });
            }
            this.setState({ tenderAmount: order.tender_amount });
            this.setState({ remarks: order.remarks });
        });
        this.randomString = () => {
            return (Math.random() + 1).toString(36).substring(2);
        };
        this.getCategories = () => {
            httpService
                .get(`/inventory/categories`)
                .then((response) => {
                this.setState({ categories: response.data.data });
            })
                .finally(() => {
                this.setState({ isLoadingCategories: false });
            });
        };
        this.updateOrder = () => {
            if (this.state.cart.length == 0) {
                toast.error(t('No items has been added!', 'لم يتم إضافة اية اصناف!'));
                return;
            }
            this.setState({ isLoading: true });
            httpService
                .post(`/orders/update/${this.state.orderId}`, {
                customer: this.state.customer,
                cart: this.state.cart,
                deletedProducts: this.state.deletedProducts,
                subtotal: this.state.subtotal,
                total: this.state.total,
                tax_rate: this.state.tax || 0,
                vat_type: this.state.vatType,
                delivery_charge: this.state.deliveryCharge || 0,
                discount: this.state.discount || 0,
                remarks: this.state.remarks,
                tender_amount: this.state.tenderAmount || 0,
                price_type: this.state.currentPrice || 0,
                sale_type: this.state.isQuotation ? undefined : this.state.saleType,
                _method: 'PUT'
            })
                .then((response) => {
                if (response.data) {
                    this.closeModal('checkoutModal');
                    Swal.fire({
                        title: t('Updated', 'تم التحديث'),
                        text: t('Invoice has been updated!', '"تم تحديث الفاتورة!"'),
                        icon: 'success',
                        allowOutsideClick: false,
                        confirmButtonText: t('Continue', 'المتابعة')
                    }).then(result => {
                        if (result.isConfirmed) {
                            window.location.href = `/orders/${this.state.orderId}`;
                        }
                    });
                }
            })
                .finally(() => this.setState({ isLoading: false }));
        };
        this.categoryClick = (category) => {
            this.setState({ showProducts: true });
            this.setState({ products: category.products || [] });
            this.setState({ categoryName: category.name });
        };
        this.backClick = () => {
            this.setState({ showProducts: false });
            this.setState({ products: [] });
            this.setState({ categoryName: '' });
        };
        this.toggleFullScreen = () => {
            toogleFullScreen();
            this.setState({ isFullScreen: !this.state.isFullScreen });
        };
        this.goToOrderList = () => {
            window.location.href = '/orders';
        };
        this.calculateTotal = () => {
            let _total = 0;
            let _subtotal = 0;
            if (this.state.cart.length > 0) {
                this.state.cart.map((item) => {
                    _subtotal += (item.price || 0) * (item.quantity || 0);
                    // _subtotal += ((this.state.currentPrice === 0 ? item.retailsale_price : item.wholesale_price) || 0) * (item.quantity || 0);
                });
            }
            let taxValue = 0;
            if (this.state.vatType == 'add') {
                if ((this.state.tax || 0) > 0 && (this.state.tax || 0) <= 100) {
                    taxValue = (Number(this.state.tax || 0) * Number(_subtotal)) / 100;
                }
            }
            _total = Number(_subtotal) + Number(taxValue) + Number(this.state.deliveryCharge || 0) - Number(this.state.discount || 0);
            this.setState({ subtotal: _subtotal });
            this.setState({ total: _total });
            this.setState({ tenderAmount: _total });
        };
        this.getVat = () => {
            var vat = this.state.tax || 0;
            if (vat <= 0)
                return 0;
            var grossAmount = this.state.subtotal || 0;
            var taxAmount = this.getTaxAmount();
            return Math.round(Number(grossAmount) - Number(taxAmount));
        };
        this.getTaxAmount = () => {
            var vat = this.state.tax || 0;
            if (vat <= 0)
                return 0;
            var grossAmount = this.state.subtotal || 0;
            return Math.trunc(Number(grossAmount) / Number(Number(1) + Number(vat) / Number(100)));
        };
        this.getTotalTax = () => {
            let taxValue = 0;
            if (Number(this.state.tax || 0) > 0 && Number(this.state.tax || 0) <= 100) {
                taxValue = (Number(this.state.tax || 0) * Number(this.state.subtotal)) / 100;
            }
            return Number(taxValue);
        };
        this.handleDiscountChange = (event) => {
            var value = event.target.value;
            if (Number(value) < 0)
                return;
            var discountValue = value == '' ? undefined : Number(value);
            this.setState({ discount: discountValue }, () => {
                this.calculateTotal();
            });
        };
        this.handleTaxChange = (event) => {
            var value = event.target.value;
            if (Number(value) < 0)
                return;
            var taxValue = value == '' ? undefined : Number(value);
            this.setState({ tax: taxValue }, () => {
                this.calculateTotal();
            });
        };
        this.handleDeliveryChargeChange = (event) => {
            var value = event.target.value;
            if (Number(value) < 0)
                return;
            var deliveryChargeValue = value == '' ? undefined : Number(value);
            this.setState({ deliveryCharge: deliveryChargeValue }, () => {
                this.calculateTotal();
            });
        };
        this.updateItemQuantity = (event, item) => {
            var value = event.target.value;
            let cartItems = this.state.cart;
            let _prod = this.state.cart.find(p => p.cartId === item.cartId);
            if (!_prod)
                return;
            if (Number(value) < 0)
                return;
            _prod.quantity = value == '' ? undefined : Number(value);
            this.setState({ cart: cartItems }, () => {
                this.calculateTotal();
            });
        };
        this.updateItemPrice = (event, item) => {
            var value = event.target.value;
            let cartItems = this.state.cart;
            let _prod = this.state.cart.find(p => p.cartId === item.cartId);
            if (!_prod)
                return;
            if (Number(value) < 0)
                return;
            _prod.price = value == '' ? undefined : Number(value);
            this.setState({ cart: cartItems }, () => {
                this.calculateTotal();
            });
        };
        this.updateItemDiscount = (event, item) => {
            const value = event.currentTarget.value;
            const discount = value === '' ? 0 : Number(value);
            if (!Number.isFinite(discount) || discount < 0 || discount > 100)
                return;
            const cartItems = this.state.cart;
            const product = cartItems.find(cartItem => cartItem.cartId === item.cartId);
            if (!product)
                return;
            const quantity = Number(product.quantity || 0);
            const price = Number(product.price || 0);
            const previousDiscount = (quantity * price * Number(product.discount || 0)) / 100;
            const updatedDiscount = (quantity * price * discount) / 100;
            product.discount = discount;
            this.setState({
                cart: cartItems,
                discount: Number(this.state.discount || 0) + updatedDiscount - previousDiscount
            }, () => this.calculateTotal());
        };
        this.currencyFormatValue = (number) => {
            var settings = JSON.parse(this.props.settings);
            return currency_format(number, settings.currencyPrecision, settings.currencyDecimalSeparator, settings.currencyThousandSeparator, settings.currencyPosition, settings.currencySymbol, settings.trailingZeros);
        };
        this.getChangeAmount = () => {
            return (this.state.tenderAmount || 0) - this.state.total;
        };
        this.handleTenderAmountChange = (event) => {
            var value = event.target.value;
            if (Number(value) < 0)
                return;
            var tenderAmount = value == '' ? undefined : Number(value);
            this.setState({ tenderAmount: tenderAmount });
        };
        this.handleSaleTypeChange = (event) => {
            this.setState({ saleType: event.currentTarget.value === 'government' ? 'government' : 'customer' });
        };
        this.handleRemarksChange = (event) => {
            this.setState({ remarks: event.currentTarget.value });
        };
        this.removeItem = (item) => {
            let newCartItems = this.state.cart.filter(i => i.cartId != item.cartId);
            this.setState({ cart: newCartItems }, () => {
                this.calculateTotal();
                this.setState({ deletedProducts: [item, ...this.state.deletedProducts] });
            });
        };
        this.addToCart = (product) => {
            let cartItem = {
                cartId: uuid(),
                id: product.id,
                name: product.name,
                full_name: product.full_name,
                description: product.description,
                image_url: product.image_url,
                price: this.state.currentPrice === 0 ? product.retailsale_price : product.wholesale_price,
                wholesale_price: product.wholesale_price,
                retailsale_price: product.retailsale_price,
                // barcode: product.barcode,
                wholesale_barcode: product.wholesale_barcode,
                retail_barcode: product.retail_barcode,
                // sku: product.sku,
                wholesale_sku: product.wholesale_sku,
                retail_sku: product.retail_sku,
                in_stock: product.in_stock,
                track_stock: product.track_stock,
                continue_selling_when_out_of_stock: product.continue_selling_when_out_of_stock,
                quantity: 1,
                old_quantity: 0,
                cost: product.cost
            };
            this.setState({ cart: [cartItem, ...this.state.cart] }, () => {
                this.calculateTotal();
            });
        };
        this.handleSearchSubmit = (event) => {
            var _b;
            event.preventDefault();
            let search = this.state.searchValue;
            if (!search)
                return;
            let searchValue = search.trim();
            // Check if the barcode is 18 characters long
            if (searchValue.length === 18 && /^\d+$/.test(searchValue)) {
                // Extract values from barcode
                let flag = searchValue.substring(0, 1);
                let itemCode = searchValue.substring(1, 7);
                let weight = parseFloat(searchValue.substring(7, 12)) / 1000; // Convert to kg
                let totalPrice = parseFloat(searchValue.substring(12, 17)) / 100; // Convert to decimal
                // Calculate unit price per kg
                let unitPricePerKg = totalPrice / weight;
                console.log('Extracted Barcode Details:', { flag, itemCode, weight, totalPrice, unitPricePerKg });
                // Search for the product by matching the retail_barcode
                let foundProduct;
                this.state.categories.forEach(category => {
                    let product = category.products.find(p => p.retail_barcode === itemCode);
                    if (product) {
                        foundProduct = product;
                    }
                });
                if (foundProduct) {
                    console.log('Product found:', foundProduct);
                    // Check if the product is already in the cart
                    let cartItem = this.state.cart.find(p => p.id === foundProduct.id);
                    if (cartItem) {
                        // Update quantity and price
                        cartItem.quantity = ((_b = cartItem.quantity) !== null && _b !== void 0 ? _b : 0) + weight;
                        cartItem.price = totalPrice;
                    }
                    else {
                        // Fix: Ensure all required properties are present
                        let newItem = {
                            cartId: uuid(),
                            id: foundProduct.id,
                            name: foundProduct.name,
                            full_name: foundProduct.full_name,
                            description: foundProduct.description,
                            image_url: foundProduct.image_url,
                            price: unitPricePerKg,
                            wholesale_price: foundProduct.wholesale_price,
                            retailsale_price: foundProduct.retailsale_price,
                            retail_barcode: foundProduct.retail_barcode,
                            wholesale_barcode: foundProduct.wholesale_barcode || '',
                            wholesale_sku: foundProduct.wholesale_sku || '',
                            retail_sku: foundProduct.retail_sku || '',
                            in_stock: foundProduct.in_stock,
                            track_stock: foundProduct.track_stock,
                            continue_selling_when_out_of_stock: foundProduct.continue_selling_when_out_of_stock,
                            quantity: weight,
                            old_quantity: 0,
                            cost: foundProduct.cost
                        };
                        this.setState({ cart: [...this.state.cart, newItem] }, () => {
                            this.calculateTotal();
                        });
                    }
                    // Clear search input
                    this.setState({ searchValue: null });
                    let searchInput = document.getElementById('barcode-input');
                    if (searchInput)
                        searchInput.value = '';
                }
                else {
                    toast.error(t('Product not found!', 'لم يتم العثور على المنتج!'));
                }
                return;
            }
            // If barcode is not 18 digits, fallback to normal search
            let productFound = 0;
            this.state.categories.forEach(category => {
                let product = category.products.find(p => {
                    var _b, _j, _k, _q;
                    return p.name.toLowerCase().includes(`${searchValue}`.toLowerCase()) ||
                        ((_b = p === null || p === void 0 ? void 0 : p.description) === null || _b === void 0 ? void 0 : _b.toLowerCase().includes(`${searchValue}`.toLowerCase())) ||
                        ((_j = p === null || p === void 0 ? void 0 : p.retail_barcode) === null || _j === void 0 ? void 0 : _j.toLowerCase()) == searchValue ||
                        ((_k = p === null || p === void 0 ? void 0 : p.retail_barcode) === null || _k === void 0 ? void 0 : _k.toLowerCase().endsWith(`${searchValue}`.toLocaleLowerCase())) ||
                        p.name.toLowerCase().endsWith(`${searchValue}`.toLocaleLowerCase()) ||
                        ((_q = p === null || p === void 0 ? void 0 : p.retail_sku) === null || _q === void 0 ? void 0 : _q.toLowerCase()) == `${searchValue}`;
                });
                if (product) {
                    console.log(product === null || product === void 0 ? void 0 : product.name);
                    this.addToCart(product);
                    productFound = 1;
                }
            });
            if (productFound === 0) {
                toast.error(t('No results found!', 'لم يتم العثور على نتائج!'));
            }
        };
        // handleSearchSubmit = (event: React.FormEvent<HTMLFormElement>): void => {
        //     event.preventDefault();
        //     let search = this.state.searchValue;
        //     if (!search) return;
        //     let searchValue = search.toLowerCase().trim();
        //     let productFound = false;
        //     this.state.categories.map((category: ICategory) => {
        //         let _prod = category.products.find(
        //             p => p.name.toLowerCase().includes(searchValue) || p?.barcode?.toLowerCase() == searchValue || p?.sku?.toLowerCase() == searchValue
        //         );
        //         if (_prod) {
        //             this.addToCart(_prod);
        //             productFound = true;
        //             return;
        //         }
        //     });
        //     if (!productFound) {
        //         toast.error(t('No results found!', 'لم يتم العثور على نتائج!'));
        //     }
        // };
        this.handleSearchChange = (event) => {
            this.setState({ searchValue: event.currentTarget.value });
        };
        this.handleCustomerSearchChange = (event) => {
            var searchQuery = event.currentTarget.value.trim();
            if (!searchQuery) {
                this.setState({ customers: [] });
                return;
            }
            httpService
                .get(`/customers/search/all?query=${searchQuery}`)
                .then((response) => {
                this.setState({ customers: response.data.data });
            })
                .finally(() => { });
        };
        this.setCustomer = (customer) => {
            this.setState({ customer: customer });
        };
        this.closeModal = (id) => {
            const createModal = document.querySelector(`#${id}`);
            if (createModal) {
                var modalInstance = Modal.getInstance(createModal);
                if (modalInstance) {
                    modalInstance.hide();
                }
            }
        };
        this.createCustomer = (e) => {
            e.preventDefault();
            if (!this.state.customerName) {
                toast.error(t('Customer name is required!', 'اسم الزبون مطلوب!'));
                return;
            }
            this.setState({ isLoading: true });
            httpService
                .post(`/customers/create-new`, {
                name: this.state.customerName,
                email: this.state.customerEmail,
                mobile: this.state.customerMobile,
                car_type_id: this.state.customerCarTypeId,
                car_name: this.state.customerCarName,
                car_chassis_number: this.state.customerCarChassisNumber,
                city: this.state.customerCity,
                building: this.state.customerBuilding,
                street_address: this.state.customerStreet,
                floor: this.state.customerFloor,
                apartment: this.state.customerApartment
            })
                .then((response) => {
                this.setCustomer(response.data.data);
                this.setState({ customerName: '' });
                this.setState({ customerEmail: '' });
                this.setState({ customerMobile: '' });
                this.setState({ customerCarTypeId: '' });
                this.setState({ customerCarName: '' });
                this.setState({ customerCarChassisNumber: '' });
                this.setState({ customerBuilding: '' });
                this.setState({ customerStreet: '' });
                this.setState({ customerFloor: '' });
                this.setState({ customerApartment: '' });
                var form = document.getElementById('create-customer-form');
                if (form) {
                    form.reset();
                }
                this.closeModal('createCustomerModal');
                toast.info(t('Customer has been created', 'تم إنشاء زبون جديد'));
            })
                .finally(() => {
                this.setState({ isLoading: false });
            });
        };
        this.handleVatTypeChange = (event) => {
            this.setState({ vatType: event.target.value }, () => {
                this.calculateTotal();
            });
        };
        this.handleCustomerNameChange = (event) => {
            this.setState({ customerName: event.currentTarget.value });
        };
        this.handleCustomerEmailChange = (event) => {
            this.setState({ customerEmail: event.currentTarget.value });
        };
        this.handleCustomerMobileChange = (event) => {
            this.setState({ customerMobile: event.currentTarget.value });
        };
        this.handleCustomerCarTypeChange = (event) => {
            this.setState({ customerCarTypeId: event.currentTarget.value });
        };
        this.handleCustomerCarNameChange = (event) => {
            this.setState({ customerCarName: event.currentTarget.value });
        };
        this.handleCustomerCarChassisNumberChange = (event) => {
            this.setState({ customerCarChassisNumber: event.currentTarget.value });
        };
        this.handleCustomerCityChange = (event) => {
            this.setState({ customerCity: event.currentTarget.value });
        };
        this.handleCustomerStreetChange = (event) => {
            this.setState({ customerStreet: event.currentTarget.value });
        };
        this.handleCustomerBuildingChange = (event) => {
            this.setState({ customerBuilding: event.currentTarget.value });
        };
        this.handleCustomerFloorChange = (event) => {
            this.setState({ customerFloor: event.currentTarget.value });
        };
        this.handleCustomerApartmentChange = (event) => {
            this.setState({ customerApartment: event.currentTarget.value });
        };
        this.modalCloseButton = () => {
            return React.createElement("button", { type: "button", className: "btn-close", "data-bs-dismiss": "modal", "aria-label": "Close" });
        };
        this.pricesFilter = () => {
            return (React.createElement("div", { className: "dropdown" },
                React.createElement("button", { type: "button", className: "nav-link bg-white border px-3 py-2 rounded-3 clickable-cell", "data-bs-toggle": "modal", "data-bs-target": "#myModal" },
                    React.createElement("div", { className: "d-flex align-items-center" },
                        React.createElement("div", { className: "d-flex justify-content-between align-items-center" },
                            React.createElement("div", { className: "me-5" }, priceFilterList[this.state.currentPrice]),
                            React.createElement(ChevronDownIcon, { className: "hero-icon-xs" }))))));
        };
        this.handleSelectRadio = (index) => {
            const cart = this.state.cart.map((item) => {
                let cartItem = {
                    cartId: uuid(),
                    id: item.id,
                    name: item.name,
                    full_name: item.full_name,
                    description: item.description,
                    image_url: item.image_url,
                    price: index === 0 ? item.retailsale_price : item.wholesale_price,
                    wholesale_price: item.wholesale_price,
                    retailsale_price: item.retailsale_price,
                    // barcode: item.barcode,
                    wholesale_barcode: item.wholesale_barcode,
                    retail_barcode: item.retail_barcode,
                    // sku: item.sku,
                    wholesale_sku: item.wholesale_sku,
                    retail_sku: item.retail_sku,
                    in_stock: item.in_stock,
                    track_stock: item.track_stock,
                    continue_selling_when_out_of_stock: item.continue_selling_when_out_of_stock,
                    quantity: 1,
                    old_quantity: 0,
                    cost: item.cost
                };
                return cartItem;
            });
            // console.log(this.state.cart);
            // console.log(cart);
            // this.setState({});
            this.setState({ cart: cart, currentPrice: index }, () => {
                this.calculateTotal();
            });
            this.closeModal('myModal');
        };
        this.pricesFilterModal = () => {
            return (React.createElement("div", { className: "modal zoom-out-entrance", id: "myModal", tabIndex: -1, "aria-labelledby": "myModalLabel", "aria-hidden": "true" },
                React.createElement("div", { className: "modal-dialog modal-dialog-centered" },
                    React.createElement("div", { className: "modal-content" },
                        React.createElement("div", { className: "modal-header" },
                            React.createElement("div", { className: "d-flex justify-content-between w-100 user-select-none cursor-pointer", onClick: () => this.handleSelectRadio(0) },
                                React.createElement("div", null, priceFilterList[0]),
                                React.createElement("input", { type: "radio", checked: this.state.currentPrice === 0 }))),
                        React.createElement("div", { className: "modal-body" },
                            React.createElement("div", { className: "d-flex justify-content-between user-select-none cursor-pointer", onClick: () => this.handleSelectRadio(1) },
                                React.createElement("div", null, priceFilterList[1]),
                                React.createElement("input", { type: "radio", checked: this.state.currentPrice === 1 }))),
                        React.createElement("div", { className: "modal-footer" },
                            React.createElement("div", { className: "d-flex justify-content-between w-100 user-select-none cursor-pointer", onClick: () => this.handleSelectRadio(2) },
                                React.createElement("div", null, priceFilterList[2]),
                                React.createElement("input", { type: "radio", checked: this.state.currentPrice === 2 })))))));
        };
        this.state = {
            orderId: '',
            orderNumber: '',
            saleType: 'customer',
            isQuotation: false,
            categories: [],
            products: [],
            cart: [],
            deletedProducts: [],
            customers: [],
            customer: undefined,
            customerName: null,
            customerEmail: null,
            customerMobile: null,
            customerCity: null,
            customerBuilding: null,
            customerStreet: null,
            customerFloor: null,
            customerApartment: null,
            showProducts: false,
            categoryName: null,
            subtotal: 0,
            total: 0,
            tax: 0,
            vatType: this.getAppSettings().vatType,
            deliveryCharge: 0,
            discount: 0,
            searchValue: null,
            remarks: null,
            isFullScreen: isFullScreen(),
            tenderAmount: 0,
            isLoading: false,
            isLoadingCategories: true,
            currentPrice: 0,
            customerCarTypeId: null,
            customerCarName: null,
            customerCarChassisNumber: null
        };
    }
    componentDidMount() {
        this.setupForEditing().then(() => {
            this.calculateTotal();
        });
        this.getCategories();
    }
    selectCustomer(customer) {
        this.setState({ customer: customer });
        this.closeModal('customerModal');
    }
    removeCustomer() {
        this.setState({ customer: undefined });
    }
    render() {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "d-flex py-3" },
                React.createElement("div", { className: " flex-grow-1" },
                    React.createElement("button", { className: "btn btn-outline-primary me-2", onClick: event => this.goToOrderList() }, t('Back', 'العودة')),
                    React.createElement("button", { className: "btn btn-light me-2 bg-white border", "data-bs-toggle": "modal", "data-bs-target": "#customerModal" },
                        React.createElement("span", { className: "d-flex align-items-center" },
                            React.createElement(UserCircleIcon, { className: "hero-icon me-1" }),
                            " ",
                            t('Customer', 'الزبون')))),
                this.pricesFilter(),
                this.pricesFilterModal()),
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-md-6" },
                    React.createElement("div", { className: "card w-100 card-gutter rounded-0" },
                        React.createElement("div", { className: "card-header bg-white border-bottom-0 p-0" },
                            React.createElement("form", { onSubmit: event => this.handleSearchSubmit(event) },
                                React.createElement("input", { type: "search", className: "form-control form-control-lg rounded-0", name: "search", id: "barcode-input", placeholder: t('Scan barcode or search by name or SKU', 'امسح الباركود ضوئيًا أو ابحث بالاسم أو SKU'), onChange: event => this.handleSearchChange(event) })),
                            React.createElement("div", { className: "p-3" },
                                t('Invoice', 'الفاتورة'),
                                " ",
                                React.createElement("span", { className: "fw-bold" }, this.state.orderNumber))),
                        React.createElement("div", { className: "card-body p-0 overflow-auto", id: "cartItems" },
                            React.createElement("table", { className: "table table-bordered mb-0" },
                                React.createElement("thead", null,
                                    React.createElement("tr", null,
                                        React.createElement("td", { width: 300, className: "p-3 fw-bold" }, t('Item', 'الصنف')),
                                        React.createElement("td", { width: 150, className: "text-center p-3 fw-bold" }, t('Quantity', 'الكمية')),
                                        React.createElement("td", { width: 150, className: "text-center p-3 fw-bold" }, t('Discount (%)', 'الخصم (%)')),
                                        React.createElement("td", { width: 150, className: "text-center p-3 fw-bold" }, t('Total', 'المجموع')))),
                                React.createElement("tbody", null, this.state.cart.length > 0 ? (React.createElement(React.Fragment, null, this.state.cart.map((item) => {
                                    var _b;
                                    return (React.createElement("tr", { key: item.cartId },
                                        React.createElement("td", { width: 300 },
                                            React.createElement("div", { className: " d-flex" },
                                                React.createElement("div", { className: "me-2 d-flex align-items-center" },
                                                    React.createElement("img", { src: item.image_url, alt: "img", className: "rounded-2", height: 50 })),
                                                React.createElement("div", null,
                                                    React.createElement("div", { className: "fw-bold" },
                                                        item.description,
                                                        " - ",
                                                        item.full_name),
                                                    React.createElement("div", { className: "fw-normal" },
                                                        React.createElement("input", { type: "number", className: "form-control text-center", value: item.price, onFocus: e => e.target.select(), onChange: e => this.updateItemPrice(e, item) })),
                                                    React.createElement("div", { className: "fw-normal mt-1" },
                                                        t('Cost', 'التكلفة'),
                                                        ": ",
                                                        this.currencyFormatValue(item.cost || 0))),
                                                React.createElement("div", { className: "ms-auto d-flex align-items-center" },
                                                    React.createElement(XCircleIcon, { className: "hero-icon-sm align-middle text-danger cursor-pointer user-select-none", onClick: event => this.removeItem(item) })))),
                                        React.createElement("td", { width: 150, className: "p-0 align-middle text-center" },
                                            React.createElement("input", { type: "number", className: "form-control text-center fw-bold form-control-lg", value: item.quantity, onFocus: e => e.target.select(), onChange: event => this.updateItemQuantity(event, item) })),
                                        React.createElement("td", { width: 150, className: "p-0 align-middle text-center" },
                                            React.createElement("input", { type: "number", min: "0", max: "100", step: "0.01", className: "form-control text-center fw-bold form-control-lg", "aria-label": t('Discount (%)', 'الخصم (%)'), value: (_b = item.discount) !== null && _b !== void 0 ? _b : 0, onFocus: e => e.target.select(), onChange: event => this.updateItemDiscount(event, item) })),
                                        React.createElement("td", { width: 150, className: "text-center align-middle" }, this.currencyFormatValue(((item.quantity || 0) * (item.price || 0) * (100 - Number(item.discount || 0))) / 100))));
                                }))) : (React.createElement(React.Fragment, null,
                                    React.createElement("tr", null,
                                        React.createElement("td", { colSpan: 4, className: "p-3 text-center align-middle fs-5" }, t('No items added...', 'لا توجد اصناف مضافة ...')))))))),
                        React.createElement("div", { className: " card-footer p-0 bg-white", id: "orderDetails" },
                            React.createElement("table", { className: "table table-bordered mb-0" },
                                React.createElement("tbody", null,
                                    React.createElement("tr", null,
                                        React.createElement("td", { width: 200 },
                                            t('Customer', 'الزبون'),
                                            ": ",
                                            this.state.customer ? this.state.customer.name : 'N/A',
                                            this.state.customer && (React.createElement("div", { className: "float-end" },
                                                React.createElement(XCircleIcon, { className: "hero-icon-sm align-middle text-danger cursor-pointer user-select-none", onClick: event => this.removeCustomer() })))),
                                        React.createElement("td", { width: 200, className: "text-end" }, t('Subtotal', 'المجموع')),
                                        React.createElement("td", { width: 200, className: "align-middle text-center" }, this.currencyFormatValue(this.state.subtotal))),
                                    React.createElement("tr", null,
                                        React.createElement("td", { width: 200, className: "text-start align-middle clickable-cell", "data-bs-toggle": "modal", "data-bs-target": "#deliveryChargeModal" },
                                            t('Delivery Charge', 'رسوم التوصيل'),
                                            ":",
                                            ' ',
                                            this.state.deliveryCharge ? this.currencyFormatValue(this.state.deliveryCharge) : 'N/A'),
                                        React.createElement("td", { width: 200, className: "text-end align-middle clickable-cell", "data-bs-toggle": "modal", "data-bs-target": "#discountModal" }, t('Discount', 'الخصم')),
                                        React.createElement("td", { width: 200, className: "text-center text-danger align-middle clickable-cell", "data-bs-toggle": "modal", "data-bs-target": "#discountModal" }, this.currencyFormatValue(this.state.discount || 0))),
                                    React.createElement("tr", { className: " alert-success" },
                                        this.state.vatType == 'add' ? (React.createElement("td", { width: 200, className: "text-start clickable-cell", "data-bs-toggle": "modal", "data-bs-target": "#taxModal" },
                                            t('VAT', 'الضريبة'),
                                            " ",
                                            this.state.tax,
                                            "%: ",
                                            this.currencyFormatValue(this.getTotalTax()))) : (React.createElement("td", { width: 200, className: "text-start clickable-cell", "data-bs-toggle": "modal", "data-bs-target": "#taxModal" },
                                            React.createElement("div", null,
                                                t('TAX.AMOUNT', 'قيمة الضريبة'),
                                                ": ",
                                                this.currencyFormatValue(this.getTaxAmount())),
                                            React.createElement("div", null,
                                                t('VAT', 'الضريبة'),
                                                " ",
                                                this.state.tax,
                                                "%: ",
                                                this.currencyFormatValue(this.getVat())))),
                                        React.createElement("td", { width: 200, className: "fw-bold text-end fs-5 align-middle" }, t('Total', 'الإجمالي')),
                                        React.createElement("td", { width: 200, className: "text-center align-middle fw-bold fs-5" }, this.currencyFormatValue(this.state.total)))))),
                        React.createElement("button", { type: "button", className: "btn btn-info py-4 rounded-0 shadow-sm fs-3 btn-lg w-100", "data-bs-toggle": "modal", "data-bs-target": "#checkoutModal" }, t(' UPDATED CHECKOUT', 'تحديث')))),
                React.createElement("div", { className: "col-md-6" },
                    React.createElement("div", { className: "card w-100 card-gutter rounded-0" },
                        React.createElement("div", { className: "card-header bg-white" },
                            React.createElement("div", { className: "d-flex px-0", style: { minHeight: 'calc(1.5em + 1rem + 5px)', padding: '0.5rem' } },
                                React.createElement("a", { className: "text-decoration-none cursor-pointer pe-2 fs-5", onClick: event => this.backClick() }, t('CATEGORIES', 'الفئات')),
                                this.state.showProducts && (React.createElement(React.Fragment, null,
                                    React.createElement("i", { className: "bi bi-arrow-right align-middle pe-2 fs-5" }),
                                    React.createElement("span", { className: "fw-normal text-muted pe-2 fs-5 text-uppercase", "aria-current": "page" }, this.state.categoryName),
                                    React.createElement("i", { className: "bi bi-arrow-right align-middle pe-2 fs-5" }))))),
                        React.createElement("div", { className: "card-body overflow-auto py-0" },
                            this.state.isLoadingCategories && (React.createElement("div", { className: "py-5" },
                                React.createElement("div", { className: "d-flex justify-content-center m-2" },
                                    React.createElement("div", { className: "spinner-border text-primary", role: "status", style: { width: '4rem', height: '4rem' } },
                                        React.createElement("span", { className: "visually-hidden" }, t('Loading...', 'جاري التحميل...')))),
                                React.createElement("div", { className: "fw-bold h3 text-center" }, t('Loading...', 'جاري التحميل...')))),
                            !this.state.showProducts && (React.createElement(React.Fragment, null, this.state.categories.length > 0 && (React.createElement("div", { className: "row" }, this.state.categories.map((category) => {
                                return (React.createElement("div", { key: category.id, className: "col-lg-4 col-md-4 col-sm-6 col-6 mb-0 p-0" },
                                    React.createElement("div", { className: "position-relative w-100 border cursor-pointer user-select-none", onClick: event => this.categoryClick(category) },
                                        React.createElement("picture", null,
                                            React.createElement("source", { type: "image/jpg", srcSet: category.image_url }),
                                            React.createElement("img", { alt: category.name, src: category.image_url, "aria-hidden": "true", className: "object-fit-cover h-100 w-100" })),
                                        React.createElement("div", { className: "position-absolute bottom-0 start-0 h-100 d-flex flex-column align-items-center justify-content-center p-4 mb-0 w-100 cell-item-label text-center" },
                                            React.createElement("div", { className: "product-name", dir: "auto" }, category.name)))));
                            }))))),
                            this.state.showProducts && (React.createElement(React.Fragment, null, this.state.products.length > 0 && (React.createElement("div", { className: "row overflow-auto" }, this.state.products.map((product) => {
                                return (React.createElement("div", { key: product.id, className: "col-lg-4 col-md-4 col-sm-6 col-6 mb-0 p-0" },
                                    React.createElement("div", { className: "position-relative w-100 border cursor-pointer user-select-none", onClick: event => this.addToCart(product) },
                                        React.createElement("picture", null,
                                            React.createElement("source", { type: "image/jpg", srcSet: product.image_url }),
                                            React.createElement("img", { alt: product.name, src: product.image_url, "aria-hidden": "true", className: "object-fit-cover h-100 w-100" })),
                                        React.createElement("div", { className: "position-absolute bottom-0 start-0 h-100 d-flex flex-column align-items-center justify-content-center p-4 mb-0 w-100 cell-item-label text-center" },
                                            React.createElement("div", { className: "fw-bold", dir: "auto" }, product.full_name),
                                            React.createElement("div", { className: "fw-normal" }, this.currencyFormatValue((this.state.currentPrice === 0
                                                ? product.retailsale_price
                                                : product.wholesale_price) || 0)),
                                            React.createElement("div", { className: "fw-normal" }, product.in_stock),
                                            React.createElement("div", { className: "fw-normal", dir: "auto" }, product.description)))));
                            }))))))))),
            React.createElement("div", { className: "modal", id: "discountModal", tabIndex: -1, "aria-labelledby": "discountModalLabel", "aria-hidden": "true" },
                React.createElement("div", { className: "modal-dialog modal-dialog-centered" },
                    React.createElement("div", { className: "modal-content" },
                        React.createElement("div", { className: "modal-header" },
                            React.createElement("h5", { className: "modal-title", id: "discountModalLabel" }, t('Discount', 'الخصم')),
                            this.modalCloseButton()),
                        React.createElement("div", { className: "modal-body" },
                            React.createElement("h3", { className: "text-center" }, this.currencyFormatValue(this.state.discount || 0)),
                            React.createElement("div", { className: "mb-3" },
                                React.createElement("input", { type: "number", className: "form-control form-control-lg text-center", onFocus: e => e.target.select(), value: this.state.discount, onChange: event => this.handleDiscountChange(event) })))))),
            React.createElement("div", { className: "modal", id: "deliveryChargeModal", tabIndex: -1, "aria-labelledby": "deliveryChargeModalLabel", "aria-hidden": "true" },
                React.createElement("div", { className: "modal-dialog modal-dialog-centered" },
                    React.createElement("div", { className: "modal-content" },
                        React.createElement("div", { className: "modal-header" },
                            React.createElement("h5", { className: "modal-title d-flex", id: "deliveryChargeModalLabel" }, t('Delivery Charge', 'رسوم التوصيل')),
                            this.modalCloseButton()),
                        React.createElement("div", { className: "modal-body" },
                            React.createElement("h3", { className: "text-center" }, this.currencyFormatValue(this.state.deliveryCharge || 0)),
                            React.createElement("div", { className: "mb-3" },
                                React.createElement("input", { type: "number", className: "form-control form-control-lg text-center", value: this.state.deliveryCharge, onFocus: e => e.target.select(), onChange: event => this.handleDeliveryChargeChange(event) })))))),
            React.createElement("div", { className: "modal", id: "taxModal", tabIndex: -1, "aria-labelledby": "taxModalLabel", "aria-hidden": "true" },
                React.createElement("div", { className: "modal-dialog modal-dialog-centered" },
                    React.createElement("div", { className: "modal-content" },
                        React.createElement("div", { className: "modal-header" },
                            React.createElement("h5", { className: "modal-title", id: "taxModalLabel" }, t('VAT', 'الضريبة')),
                            this.modalCloseButton()),
                        React.createElement("div", { className: "modal-body" },
                            React.createElement("h3", { className: "text-center" },
                                this.state.tax || 0,
                                "%"),
                            React.createElement("div", { className: "mb-3" },
                                React.createElement("input", { type: "number", className: "form-control form-control-lg text-center", onFocus: e => e.target.select(), value: this.state.tax, onChange: event => this.handleTaxChange(event) })),
                            React.createElement("div", { className: "mb-3" },
                                React.createElement("select", { name: "vatType", id: "vat-type", className: "form-select form-select-lg", onChange: this.handleVatTypeChange, value: this.state.vatType },
                                    React.createElement("option", { value: "exclude" },
                                        " ",
                                        t('Exclude', 'استثناء')),
                                    React.createElement("option", { value: "add" }, t('Add', 'إضافة')))))))),
            React.createElement("div", { className: "modal", id: "customerModal", tabIndex: -1, "aria-labelledby": "customerModalLabel", "aria-hidden": "true" },
                React.createElement("div", { className: "modal-dialog modal-dialog-centered" },
                    React.createElement("div", { className: "modal-content" },
                        React.createElement("div", { className: "modal-header" },
                            React.createElement("h5", { className: "modal-title d-flex", id: "customerModalLabel" }, t('Customer', 'الزبون')),
                            this.modalCloseButton()),
                        React.createElement("div", { className: "modal-body p-0" },
                            React.createElement("nav", null,
                                React.createElement("div", { className: "nav nav-tabs nav-justified", id: "nav-tab", role: "tablist" },
                                    React.createElement("button", { className: "nav-link rounded-0 active", id: "nav-search-customer-tab", "data-bs-toggle": "tab", "data-bs-target": "#nav-search-customer", type: "button", role: "tab", "aria-controls": "nav-search-customer", "aria-selected": "true" }, t('Search', 'ابحث')),
                                    React.createElement("button", { className: "nav-link rounded-0", id: "nav-create-customer-tab", "data-bs-toggle": "tab", "data-bs-target": "#nav-create-customer", type: "button", role: "tab", "aria-controls": "nav-create-customer", "aria-selected": "false" }, t('Create', 'إنشاء')))),
                            React.createElement("div", { className: "tab-content", id: "nav-tabContent" },
                                React.createElement("div", { className: "tab-pane fade show active", id: "nav-search-customer", role: "tabpanel", "aria-labelledby": "nav-search-customer-tab", tabIndex: 0 },
                                    React.createElement("div", { className: "position-relative w-100" },
                                        React.createElement("input", { type: "search", className: "form-control form-control-lg rounded-0 shadow-none", name: "search", id: "search", autoComplete: "off", placeholder: t('Search...', 'بحث...'), onChange: event => this.handleCustomerSearchChange(event) })),
                                    React.createElement("div", { className: "overflow-auto", style: { height: '250px' } }, this.state.customers.length > 0 && (React.createElement(React.Fragment, null, this.state.customers.map((cuts) => {
                                        return (React.createElement("div", { className: "py-2 px-3 clickable-cell border-bottom", onClick: e => this.selectCustomer(cuts), key: cuts.id },
                                            React.createElement("div", { className: "fw-bold" }, cuts.name),
                                            React.createElement("div", { className: "small text-muted" }, cuts.contact),
                                            React.createElement("div", { className: "small text-muted" }, cuts.full_address)));
                                    }))))),
                                React.createElement("div", { className: "tab-pane fade p-3", id: "nav-create-customer", role: "tabpanel", "aria-labelledby": "nav-create-customer-tab", tabIndex: 0 },
                                    React.createElement("form", { method: "POST", onSubmit: this.createCustomer, role: "form", id: "create-customer-form" },
                                        React.createElement("div", { className: "mb-3" },
                                            React.createElement("label", { className: " form-label fw-bold" },
                                                t('Customer Name', 'اسم الزبون'),
                                                "*"),
                                            React.createElement("input", { type: "text", className: "form-control form-control-lg", onChange: event => this.handleCustomerNameChange(event) })),
                                        React.createElement("div", { className: "mb-3" },
                                            React.createElement("label", { className: " form-label fw-bold" }, t('Email', 'البريد الإلكتروني')),
                                            React.createElement("input", { type: "email", className: "form-control form-control-lg", onChange: event => this.handleCustomerEmailChange(event) })),
                                        React.createElement("div", { className: "mb-3" },
                                            React.createElement("label", { className: " form-label fw-bold" }, t('Mobile Number', 'رقم الجوال')),
                                            React.createElement("input", { type: "tel", className: "form-control form-control-lg", onChange: event => this.handleCustomerMobileChange(event) })),
                                        React.createElement("div", { className: "text-muted" }, t('Address', 'العنوان')),
                                        React.createElement("div", { className: "mb-3" },
                                            React.createElement("label", { className: " form-label fw-bold" }, t('City', 'المدينة')),
                                            React.createElement("input", { type: "text", className: "form-control form-control-lg", onChange: event => this.handleCustomerCityChange(event) })),
                                        React.createElement("div", { className: "row" },
                                            React.createElement("div", { className: "col-md-6 mb-3" },
                                                React.createElement("label", { className: " form-label fw-bold" }, t('Street', 'الشارع')),
                                                React.createElement("input", { type: "text", className: "form-control form-control-lg", onChange: event => this.handleCustomerStreetChange(event) })),
                                            React.createElement("div", { className: "col-md-6 mb-3" },
                                                React.createElement("label", { className: " form-label fw-bold" }, t('Building', 'المبنى')),
                                                React.createElement("input", { type: "text", className: "form-control form-control-lg", onChange: event => this.handleCustomerBuildingChange(event) }))),
                                        React.createElement("div", { className: "row" },
                                            React.createElement("div", { className: "col-md-6 mb-3" },
                                                React.createElement("label", { className: " form-label fw-bold" }, t('Floor', 'الطابق')),
                                                React.createElement("input", { type: "text", className: "form-control form-control-lg", onChange: event => this.handleCustomerFloorChange(event) })),
                                            React.createElement("div", { className: "col-md-6 mb-3" },
                                                React.createElement("label", { className: " form-label fw-bold" }, t('Apartment', 'الشقة')),
                                                React.createElement("input", { type: "text", className: "form-control form-control-lg", onChange: event => this.handleCustomerApartmentChange(event) }))),
                                        React.createElement("div", { className: "mb-3" },
                                            React.createElement("label", { className: " form-label fw-bold" }, t('Car Type', 'الشارع')),
                                            React.createElement("select", { name: "car_type_id", id: "car_type_id", className: "form-select px-5 ms-3", value: this.state.customerCarTypeId || '', onChange: event => this.handleCustomerCarTypeChange(event) },
                                                React.createElement("option", { value: "" }, t('Select a Car Type', 'اختر الخدمة')),
                                                Array.isArray(this.getCarTypes()) &&
                                                    this.getCarTypes().map((cartype) => (React.createElement("option", { key: cartype.id, value: cartype.id }, cartype.type))))),
                                        React.createElement("div", { className: "row" },
                                            React.createElement("div", { className: "col-md-6 mb-3" },
                                                React.createElement("label", { className: " form-label fw-bold" }, t('Car Name', 'المبنى')),
                                                React.createElement("input", { type: "text", className: "form-control form-control-lg", onChange: event => this.handleCustomerCarNameChange(event) })),
                                            React.createElement("div", { className: "col-md-6 mb-3" },
                                                React.createElement("label", { className: " form-label fw-bold" }, t('Car Chassis Number', 'المدينة')),
                                                React.createElement("input", { type: "text", className: "form-control form-control-lg", onChange: event => this.handleCustomerCarChassisNumberChange(event) }))),
                                        React.createElement("button", { className: "btn btn-primary btn-lg w-100", type: "submit", disabled: this.state.isLoading }, t('Create Customer', 'إنشاء زبون جديد'))))))))),
            React.createElement("div", { className: "modal fade", id: "checkoutModal", tabIndex: -1, "aria-labelledby": "checkoutModalLabel", "aria-hidden": "true" },
                React.createElement("div", { className: "modal-dialog modal-dialog-centered modal-lg" },
                    React.createElement("div", { className: "modal-content" },
                        React.createElement("div", { className: "modal-header" },
                            React.createElement("h5", { className: "modal-title", id: "checkoutModalLabel" }),
                            this.modalCloseButton()),
                        React.createElement("div", { className: "modal-body py-0" },
                            React.createElement("div", { className: "row" },
                                React.createElement("div", { className: "col-6 py-3 bg-primary-sec" },
                                    React.createElement("table", { className: "table table-borderless" },
                                        React.createElement("tbody", null,
                                            React.createElement("tr", null,
                                                React.createElement("td", { className: "text-danger-sec" }, t('Subtotal', 'المجموع')),
                                                React.createElement("td", { className: "text-white" }, this.currencyFormatValue(this.state.subtotal))),
                                            React.createElement("tr", null,
                                                React.createElement("td", { className: "text-danger-sec" },
                                                    " ",
                                                    t('Quantity', 'الكمية')),
                                                React.createElement("td", { className: "text-white" }, this.state.cart.reduce(function (prev, current) {
                                                    return prev + +(current.quantity || 0);
                                                }, 0))),
                                            React.createElement("tr", null,
                                                React.createElement("td", { className: "text-danger-sec" }, t('Discount', 'الخصم')),
                                                React.createElement("td", { className: "text-white" }, this.currencyFormatValue(this.state.discount || 0))),
                                            React.createElement("tr", null,
                                                React.createElement("td", { className: "text-danger-sec" }, t('Delivery Charge', 'رسوم التوصيل')),
                                                React.createElement("td", { className: "text-white" }, this.currencyFormatValue(this.state.deliveryCharge || 0))),
                                            this.state.vatType == 'add' ? (React.createElement("tr", null,
                                                React.createElement("td", { className: "text-danger-sec" },
                                                    t('VAT', 'الضريبة'),
                                                    " ",
                                                    this.state.tax || 0,
                                                    "%"),
                                                React.createElement("td", { className: "text-white" }, this.currencyFormatValue(this.getTotalTax())))) : (React.createElement(React.Fragment, null,
                                                React.createElement("tr", null,
                                                    React.createElement("td", { className: "text-danger-sec" },
                                                        " ",
                                                        t('Tax Amount', 'القيمة الضريبية')),
                                                    React.createElement("td", { className: "text-white" }, this.currencyFormatValue(this.getTaxAmount()))),
                                                React.createElement("tr", null,
                                                    React.createElement("td", { className: "text-danger-sec" },
                                                        t('VAT', 'الضريبة'),
                                                        " ",
                                                        this.state.tax || 0,
                                                        "%"),
                                                    React.createElement("td", { className: "text-white" }, this.currencyFormatValue(this.getVat()))))),
                                            React.createElement("tr", { className: "fw-bold" },
                                                React.createElement("td", { className: "text-danger-sec" }, t('Total', 'المجموع الإجمالي')),
                                                React.createElement("td", { className: "text-white" }, this.currencyFormatValue(this.state.total))),
                                            this.state.customer && (React.createElement(React.Fragment, null,
                                                React.createElement("tr", null,
                                                    React.createElement("td", { className: "text-danger-sec align-middle" }, t('Customer', 'الزبون')),
                                                    React.createElement("td", { className: "text-white" }, this.state.customer.name)),
                                                React.createElement("tr", null,
                                                    React.createElement("td", { className: "text-danger-sec align-middle" }, t('Contact', 'الاتصال')),
                                                    React.createElement("td", { className: "text-white" }, this.state.customer.contact)),
                                                React.createElement("tr", null,
                                                    React.createElement("td", { className: "text-danger-sec align-middle" }, t('Address', 'العنوان')),
                                                    React.createElement("td", { className: "text-white" }, this.state.customer.full_address)))))),
                                    React.createElement("hr", null),
                                    React.createElement("div", { className: "mb-3" },
                                        React.createElement("label", { htmlFor: "remarks", className: "form-label text-danger-sec" }, t('Notes', 'الملاحظات')),
                                        React.createElement("textarea", { className: "form-control", id: "remarks", rows: 3, onChange: event => this.handleRemarksChange(event), value: this.state.remarks || '' }))),
                                React.createElement("div", { className: "col-6 py-3 bg-light d-flex flex-column" },
                                    React.createElement("div", { className: "text-center text-danger" }, t('CHECKOUT', 'الدفع')),
                                    React.createElement("hr", null),
                                    !this.state.isQuotation && (React.createElement("div", { className: "mb-3" },
                                        React.createElement("label", { htmlFor: "sale-type", className: "form-label text-center w-100" }, t('Invoice Sale Type', 'نوع بيع الفاتورة')),
                                        React.createElement("select", { id: "sale-type", className: "form-select form-select-lg text-center", value: this.state.saleType, onChange: this.handleSaleTypeChange, disabled: this.state.isLoading },
                                            React.createElement("option", { value: "customer" }, t('Customer Sale', 'بيع للعميل')),
                                            React.createElement("option", { value: "government" }, t('Government Sale', 'بيع حكومي'))))),
                                    React.createElement("div", { className: "mb-3" },
                                        React.createElement("div", { className: "form-label text-center" }, t('Tender Amount', 'المبلغ المدفوع')),
                                        React.createElement("input", { type: "number", className: "form-control form-control-lg text-center", id: "tender-amount", value: this.state.tenderAmount, onFocus: e => e.target.select(), onChange: event => this.handleTenderAmountChange(event) })),
                                    React.createElement("hr", null),
                                    React.createElement("table", { className: "table table-borderless d-none" },
                                        React.createElement("tbody", null,
                                            React.createElement("tr", { className: "fw-bold" },
                                                React.createElement("td", { className: "text-danger-sec" }, this.getChangeAmount() < 0 ? t('Owe', 'مدين') : t('Change', 'الباقي')),
                                                React.createElement("td", { className: "text-end" }, this.currencyFormatValue(this.getChangeAmount()))))),
                                    React.createElement("div", { className: "mt-auto" },
                                        React.createElement("button", { className: "btn btn-info border btn-lg w-100", disabled: this.state.isLoading, onClick: e => this.updateOrder() }, t('UPDATE', 'تحديث'))))))))),
            React.createElement(ToastContainer, { position: "bottom-left", autoClose: 2000, pauseOnHover: true, theme: "colored", hideProgressBar: true })));
    }
}
export default PointOfSaleEdit;
const element = document.getElementById('pos-edit');
if (element) {
    const props = Object.assign({}, element.dataset);
    const root = ReactDOM.createRoot(element);
    root.render(React.createElement(PointOfSaleEdit, Object.assign({ order: '', settings: '', cartypes: '' }, props)));
}
